export function formatDate(value: string): string {
  const date = new Date(value);
  if (isNaN(date.getTime())) return value;

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };

  return date.toLocaleString(undefined, options);
}
